import { ArrowRight, Sparkles, Brain, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
const Hero = () => {
  const navigate = useNavigate();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };
  return <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 hero-gradient">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-float" style={{
          animationDelay: "1s"
        }}></div>
        </div>
        {/* Tech Grid Pattern */}
        <div className="absolute inset-0" style={{
        backgroundImage: `
            linear-gradient(to right, hsl(var(--primary) / 0.1) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(var(--primary) / 0.1) 1px, transparent 1px)
          `,
        backgroundSize: "4rem 4rem"
      }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-6 animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
              <Sparkles size={16} className="text-primary" />
              <span className="text-sm font-medium text-primary">Inovação em Tecnologia</span>
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/15 border border-primary/30 glow-primary">
              <Brain size={16} className="text-primary animate-pulse" />
              <span className="text-sm font-bold text-primary">Powered by AI</span>
              <Zap size={14} className="text-primary" />
            </div>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 text-white">
            Transformamos ideias em{" "}
            <span className="text-primary">soluções digitais</span> inteligentes
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 mb-4 max-w-2xl mx-auto animate-fade-in font-medium" style={{
          animationDelay: "0.2s"
        }}>
            Desenvolvimento de sistemas, aplicativos e integrações com <span className="text-primary font-bold">Inteligência Artificial</span> para impulsionar seu negócio no mundo digital.
          </p>

          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto animate-fade-in" style={{
          animationDelay: "0.3s"
        }}>
            Utilizamos tecnologia de ponta com IA avançada para criar soluções que automatizam processos, analisam dados e transformam a forma como você faz negócios.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{
          animationDelay: "0.4s"
        }}>
            <Button size="lg" onClick={() => navigate('/servicos')} className="group">
              Nossos Serviços
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button size="lg" variant="hero" onClick={() => scrollToSection("contact")} className="text-slate-50">
              Fale Conosco
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-primary rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-primary rounded-full mt-2 animate-glow-pulse"></div>
        </div>
      </div>
    </section>;
};
export default Hero;